<script lang="ts">
  import CmsImage from '$components/cms-image.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';
  import type { TestimonialStoryblok } from '$types/bloks';

  export let block: TestimonialStoryblok;
  let className: string | undefined = undefined;
  export { className as class };
</script>

<div
  class={cn('bg-primary/4 border border-primary/4 p-4 rounded-md', className)}
  use:storyblokEditable={block}
>
  <p class="mb-8 text-lg">&ldquo;{block.quote}&rdquo;</p>
  <div class="flex gap-2">
    <div class="w-10 h-10 rounded-full overflow-hidden">
      <CmsImage image={block.image} class="object-cover h-full" />
    </div>
    <div class="flex flex-col justify-center">
      <p class="text-md font-semibold">{block.name}</p>
      <p class="text-md">{block.job_description}</p>
    </div>
  </div>
</div>
